import { PropertyColor } from './types.js';

export const PROPERTY_COLOR_HEX: Record<PropertyColor, string> = {
  [PropertyColor.BROWN]:      '#8B4513',
  [PropertyColor.LIGHT_BLUE]: '#87CEEB',
  [PropertyColor.PINK]:       '#DB7093',
  [PropertyColor.ORANGE]:     '#FF8C00',
  [PropertyColor.RED]:        '#FF0000',
  [PropertyColor.YELLOW]:     '#FFD700',
  [PropertyColor.GREEN]:      '#228B22',
  [PropertyColor.DARK_BLUE]:  '#00008B',
};

export const STARTING_MONEY = 1500;
export const GO_SALARY = 200;
export const INCOME_TAX_AMOUNT = 200;
export const LUXURY_TAX_AMOUNT = 100;
export const JAIL_FINE = 50;
export const MAX_JAIL_TURNS = 3;
export const MAX_PLAYERS = 4;
export const MIN_PLAYERS = 2;
export const BOARD_SIZE = 40;
export const JAIL_POSITION = 10;
export const GO_TO_JAIL_POSITION = 30;
export const GO_POSITION = 0;
export const MAX_HOUSES = 5; // 5 = hotel
export const TOTAL_HOUSES_SUPPLY = 32;
export const TOTAL_HOTELS_SUPPLY = 12;
export const ROOM_CODE_LENGTH = 5;

export const PLAYER_COLORS = ['#E74C3C', '#3498DB', '#2ECC71', '#F1C40F'];
export const PLAYER_TOKEN_NAMES = ['Red', 'Blue', 'Green', 'Yellow'];

export const AVATARS = [
  { id: 'tophat',      emoji: '🎩', label: 'Top Hat' },
  { id: 'car',         emoji: '🚗', label: 'Car' },
  { id: 'dog',         emoji: '🐕', label: 'Dog' },
  { id: 'boot',        emoji: '👢', label: 'Boot' },
  { id: 'ship',        emoji: '🚢', label: 'Ship' },
  { id: 'cat',         emoji: '🐈', label: 'Cat' },
  { id: 'iron',        emoji: '♨️', label: 'Iron' },
  { id: 'wheelbarrow', emoji: '🛒', label: 'Wheelbarrow' },
];
